import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { memberAsMemberQueryKeys } from "../memberAsMember";

export const useMutationMembershipSubscriptionStartDateAsMember = ({
  api,
}: {
  api: ApiType;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      opts: Parameters<
        ApiType["customerMembershipApi"]["membershipSubscriptionStartDate"]
      >[0],
    ) => api.customerMembershipApi.membershipSubscriptionStartDate(opts),
    onSuccess: async () =>
      await queryClient.invalidateQueries({
        queryKey: memberAsMemberQueryKeys.getCurrentMembershipSubscription(),
      }),
  });
};
